import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { validateEnvironment } from './environments/environment.validator';

validateEnvironment();
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
